/* script */

/**
 * GenericMenu component. This is a generic menu that can be extended.
 *
 * @vue-prop {Object} current the current page configuration.
 * @vue-prop {Object} currentSearchParams the current route search parameters.
 * @vue-prop {Object} modules an object containing all available modules.
 * @vue-prop {Boolean} parentMinified whether the main menu is minified or not.
 *
 * @category ui.components.main-menu
 * @exports GenericMenu
 * @component
 */
const __vue_script__ = {
    name: 'GenericMenu',

    props: {
        current: {
            type: Object,
            required: true
        },

        currentSearchParams: {
            type: Object,
            required: true
        },

        modules: {
            type: Object,
            required: true
        },

        parentMinified: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        /**
         * Given a link this method checks if it matches with the current route.
         *
         * @private
         *
         * @param {Object} link the link on which perform the lookup
         * @param {Boolean} [perfectMatch=true] if the match must be perfect or partial
         *
         * @returns {Boolean} true if the link matches with the current route, false otherwise
         */
        matchesRoute(link, perfectMatch = true) {
            // no routes yet
            if (!this.current) {
                return false;
            }
            const searchParams = this.$router.getSearchParams();

            return this.$services.blueprint.matchRoute(this.current, searchParams, link, perfectMatch);
        },

        /**
         * Returns relative link for given module
         *
         * @param {Object} module
         *
         * @returns {String} relative link
         */
        getLink(module) {
            let link = module;

            if (!module.routes) {
                // module is category (1st level item)
                link = this.$services.menu.getFirstCategoryLink(module);
            }

            let params = {};
            let searchParams = {};

            // application menu links don't need any parameters
            // this is needed only for the event menu
            if (this.eventId) {
                params = { eventId: this.eventId };
                searchParams = link.searchParams || {};
            }

            return this.$services.blueprint.getLinkForModule(link, params, searchParams);
        }
    }
};

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/main-menu/GenericMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__